// extracted by mini-css-extract-plugin
export default {"container":"SwitcherComponent__container___nRC8V"};